module.exports = __webpack_public_path__ + "static/media/ico-close.ee2be2e1.svg";